import axios from "../../../util/axios";

export default {

    /* 同步商品信息 */
    syncProduct: (data) => axios.get({url: '/third/common/product/syncProduct', data: data}),

}